import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { checkCards } from "../features/boardSlice";
import Card from "./Card";

const GameBoard = () => {
  const dispatch = useDispatch();
  const { cards, selectedCards, cols, level, moves, won } = useSelector(
    (store) => store.board
  );

  useEffect(() => {
    if (selectedCards.length === 2) {
      setTimeout(() => {
        dispatch(checkCards());
      }, 1000);
    }
  }, [dispatch, selectedCards]);

  return (
    <div className="game-board">
      <div className={`grid grid-cols-${cols}`}>
        {cards.map((card, i) => (
          <Card key={i} {...card} level={level} />
        ))}
      </div>
      {won && (
        <h4 className="winner">
          Congratulations, You found all matches in just {moves} moves!
        </h4>
      )}
    </div>
  );
};

export default GameBoard;
